import SmSideMenu from '@/components/common/sideMenu/SmSideMenu.vue'
import SrSideMenu from '@/components/common/sideMenu/SrSideMenu.vue'

import MSR_SO_001 from '@/views/sr/MSR_SO_001.vue' //등록
import MSR_SO_002 from '@/views/sr/MSR_SO_002.vue' //리스트조회
import MSR_SO_003 from '@/views/sr/MSR_SO_003.vue' //수정
import MSR_SO_004 from '@/views/sr/MSR_SO_004.vue' //상세조회

import MSM_SA_001 from '@/views/sm/MSM_SA_001.vue'
import MSM_SA_002 from '@/views/sm/MSM_SA_002.vue'
import MSM_SA_003 from '@/views/sm/MSM_SA_003.vue'
import MSM_SA_010 from '@/views/sm/MSM_SA_010.vue'

import MSM_SA_004 from '@/views/sm/MSM_SA_004.vue'
import MSM_SA_005 from '@/views/sm/MSM_SA_005.vue'
import MSM_SA_006 from '@/views/sm/MSM_SA_006.vue'
import MSM_SA_011 from '@/views/sm/MSM_SA_011.vue'

import MSM_SA_007 from '@/views/sm/MSM_SA_007.vue'
import MSM_SA_008 from '@/views/sm/MSM_SA_008.vue'
import MSM_SA_009 from '@/views/sm/MSM_SA_009.vue'
import MSM_SA_012 from '@/views/sm/MSM_SA_012.vue'


//영업기회 및 영업기회 관리
const salesOpportunityRouter = [

	/* 화면명 : 영업기회 등록 : MSR_SO_001  */
	{
		path: "/sr/MSR_SO_001",
		name: 'MSR_SO_001',
		components: {
            default : MSR_SO_001,
            sideMenu : SrSideMenu
        },
		meta: {
			title: '영업기회 등록',
			IADepth: ['영업기회 등록', '영업기회 등록관리', '영업기회 등록/수정'],
		}
	},

	/* 화면명 : 영업기회 조회/수정  : MSR_SO_002  */
	{
		path: "/sr/MSR_SO_002",
		name: 'MSR_SO_002',
		components: {
            default : MSR_SO_002,
            sideMenu : SrSideMenu
        },
		meta: {
			sideMenu: SrSideMenu,
			title: '영업기회 조회(List)',
			IADepth: ['영업기회 등록', '영업기회 등록관리', '영업기회 조회(List)'],
		}
	},

	/* 화면명 : 영업기회 수정  : MSR_SO_003  */
	{
		path: "/sr/MSR_SO_003",
		name: 'MSR_SO_003',
		components: {
            default : MSR_SO_003,
            sideMenu : SrSideMenu
        },
		meta: {
			sideMenu: SrSideMenu,
			title: '영업기회 수정',
			IADepth: ['영업기회 등록', '영업기회 등록관리', '영업기회 등록/수정'],
		}
	},


	/* 화면명 : 영업기회 상세조회  : MSR_SO_004  */
	{
		path: "/sr/MSR_SO_004",
		name: 'MSR_SO_004',
		components: {
            default : MSR_SO_004,
            sideMenu : SrSideMenu
        },
		meta: {
			sideMenu: SrSideMenu,
			title: '영업기회 상세조회',
			IADepth: ['영업기회 등록', '영업기회 등록관리','영업기회 상세조회'],
		}
	},


	/* 화면명 : 영업기회 알람등록 : MSM_SA_001  */
	{
		path: "/sm/MSM_SA_001",
		name: 'MSM_SA_001',
		components: {
            default : MSM_SA_001,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '영업기회 알람 등록',
			IADepth: ['영업기회 관리', '영업기회 알람기능', '영업기회 알람 등록/수정'],
		}
	},

	/* 화면명 : 영업기회 알람 조회/수정 : MSM_SA_002  */
	{
		path: "/sm/MSM_SA_002",
		name: 'MSM_SA_002',
		components: {
            default : MSM_SA_002,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '영업기회 알람 조회',
			IADepth: ['영업기회 관리', '영업기회 알람기능', '영업기회 알람 조회'],
		}
	},

	/* 화면명 : 영업기회 알람 수정 : MSM_SA_003  */
	{
		path: "/sm/MSM_SA_003",
		name: 'MSM_SA_003',
		components: {
            default : MSM_SA_003,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '영업기회 알람 수정',
			IADepth: ['영업기회 관리', '영업기회 알람기능', '영업기회 알람 등록/수정'],
		}
	},

	/* 화면명 : 영업기회 알람 상세조회 : MSM_SA_010  */
	{
		path: "/sm/MSM_SA_010",
		name: 'MSM_SA_010',
		components: {
            default : MSM_SA_010,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '영업기회 알람 상세조회',
			IADepth: ['영업기회 관리', '영업기회 알람기능', '영업기회 알람 상세조회'],
		}
	},


	/* 화면명 : 리드등록 : MSM_SA_004  */
	{
		path: "/sm/MSM_SA_004",
		name: 'MSM_SA_004',
		components: {
            default : MSM_SA_004,
            sideMenu : SmSideMenu
        },
		meta: {
			sideMenu: SmSideMenu,
			title: '리드 등록',
			IADepth: ['영업기회 관리', '리드 관리', '리드 등록/수정'],
		}
	},

	/* 화면명 : 리드 조회 : MSM_SA_005  */
	{
		path: "/sm/MSM_SA_005",
		name: 'MSM_SA_005',
		components: {
            default : MSM_SA_005,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '리드 조회',
			IADepth: ['영업기회 관리', '리드 관리', '리드 조회'],
		}
	},

	/* 화면명 : 리드 수정 : MSM_SA_006  */
	{
		path: "/sm/MSM_SA_006",
		name: 'MSM_SA_006',
		components: {
            default : MSM_SA_006,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '리드 수정',
			IADepth: ['영업기회 관리', '리드 관리', '리드 등록/수정'],
		}
	},

	/* 화면명 : 리드 상세조회 : MSM_SA_011  */
	{
		path: "/sm/MSM_SA_011",
		name: 'MSM_SA_011',
		components: {
            default : MSM_SA_011,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '리드 상세조회',
			IADepth: ['영업기회 관리', '리드 관리', '리드 상세조회'],
		}
	},

	/* 화면명 : 이벤트 등록 : MSM_SA_007  */
	{
		path: "/sm/MSM_SA_007",
		name: 'MSM_SA_007',
		components: {
            default : MSM_SA_007,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '이벤트 등록',
			IADepth: ['영업기회 관리', '이벤트 관리', '이벤트 등록/수정'],
		}
	},

	/* 화면명 : 이벤트 조회  : MSM_SA_008  */
	{
		path: "/sm/MSM_SA_008",
		name: 'MSM_SA_008',
		components: {
            default : MSM_SA_008,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '이벤트 조회',
			IADepth: ['영업기회 관리', '이벤트 관리', '이벤트 조회'],
		}
	},

	/* 화면명 : 이벤트 수정  : MSM_SA_009  */
	{
		path: "/sm/MSM_SA_009",
		name: 'MSM_SA_009',
		components: {
            default : MSM_SA_009,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '이벤트 수정',
			IADepth: ['영업기회 관리', '이벤트 관리', '이벤트 등록/수정'],
		}
	},

	/* 화면명 : 이벤트 상세조회  : MSM_SA_012  */
	{
		path: "/sm/MSM_SA_012",
		name: 'MSM_SA_012',
		components: {
            default : MSM_SA_012,
            sideMenu : SmSideMenu
        },
		meta: {
			title: '이벤트 상세조회',
			IADepth: ['영업기회 관리', '이벤트 관리', '이벤트 상세조회'],
		}
	},


	// redirect : '/sm/list'
	/*children : [
			{
					//ex ) 화면 : 영업기회 조회 list & stage
					path : '/list',
					name : 'smList',
					component: () => import('@/views/sm/List.vue')  ,
			}
	]*/


]
export { salesOpportunityRouter }
